import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkboxes } from "../../../FlowConfigurationInputs";
import FormControl from "@material-ui/core/FormControl";
import { Button, MenuItem, Select, Box } from "@material-ui/core";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import CaptureArea from "./CaptureArea";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { getExtension } from "../../../../helpers/helper";
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PropTypes from "prop-types";
// TabPanel styling
function TabPanel({ children, value, index }) {
  return <div>{value === index && <Box>{children}</Box>}</div>;
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};


const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 2,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '0.5px solid #D5D5D5',
    paddingLeft: 5,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.

  },
}))(InputBase);
/**
 * @Description this page OCR Library's Capture Text From Image Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
function CaptureTextFromImage({
  action,
  variables,
  variableRender,
  setOpenVariable,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.OCR.";
  const [localType, setLocalType] = useState("");
  const [upImg, setUpImg] = useState();
  const [value, setValue] = useState(0);

  const [openCaptureArea, setOpenCaptureArea] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState(0);
  const [imgCoordinate, setImgCoordinate] = useState({ coordinates: [] });
  const reader = new FileReader();
  const options = {
    checkboxes: { label: label + "TRIM-TEXT" },
  };

  // set initial action fields value
  useEffect(() => {
    if (!action.fields.localType) {
      action.fields.localType = { value: "" };
    } else {
      setLocalType(action.fields.localType.value);
    }
    if (!action.fields.imgURL) {
      action.fields.imgURL = { value: "" };
    } else {
      setUpImg(action.fields.imgURL.value);
    }
    if (!action.fields.completedCrop) {
      action.fields.completedCrop = { value: [] };
    } else {
      setImgCoordinate({ coordinates: action.fields.completedCrop.value });
    }
    if (!action.fields.fileName) {
      action.fields.fileName = { value: "" };
    } else {
      setFileName(action.fields.fileName.value);
    }
    if (!action.fields.fileSize) {
      action.fields.fileSize = { value: 0 };
    }
    if (!action.fields.mediaSize) {
      action.fields.mediaSize = { value: { width: 0, height: 0, div: 0 } };
    }
    if (!action.fields.gridCrop) {
      action.fields.gridCrop = { value: [] };
    }
  }, [action, variables, variableRender]);

  reader.onload = function (event) {
    let image = new Image();

    image.onload = function () {
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      if (image.width > 2000 && image.width < 3000) {
        canvas.width = image.width / 2;
        canvas.height = image.height / 2;
        context.drawImage(
          image,
          0,
          0,
          image.width,
          image.height,
          0,
          0,
          canvas.width,
          canvas.height
        );
        setUpImg(canvas.toDataURL());
        // set img size
        action.fields.mediaSize.value.div = 2;
        action.fields.mediaSize.value.width = canvas.width;
        action.fields.mediaSize.value.height = canvas.height;
        action.fields.image.byteValue = canvas.toDataURL();
      } else if (image.width > 3000) {
        canvas.width = image.width / 4;
        canvas.height = image.height / 4;
        context.drawImage(
          image,
          0,
          0,
          image.width,
          image.height,
          0,
          0,
          canvas.width,
          canvas.height
        );
        // set img size
        action.fields.mediaSize.value.div = 4;
        action.fields.mediaSize.value.width = canvas.width;
        action.fields.mediaSize.value.height = canvas.height;
        setUpImg(canvas.toDataURL());
        action.fields.image.byteValue = canvas.toDataURL();
      }
    };
    image.src = event.target.result;
  };

  //select file input
  function onSelectFile(e) {
    if (e.target.files && e.target.files.length > 0) {
      reader.addEventListener("load", () => {
        setUpImg(reader.result);
        setFileSize(reader.size);
      });
      reader.readAsDataURL(e.target.files[0]);
      const fullName = e.target.files[0].name;
      setFileSize(e.target.files[0].size);
      action.fields.fileName.value = fullName;
      setFileName(fullName);
    }
  }

  //convert base64 to buffer byte array
  useEffect(() => {
    if (upImg) {
      action.fields.image = {
        byteValue: upImg,
        value: fileName,
        extension: getExtension(fileName),
        type: "FILE",
        fileSize: fileSize ? fileSize : 0,
      };
      action.fields.imgURL.value = upImg;
      action.fields.fileSize.value = fileSize;
    }
  }, [action.fields, fileName, fileSize, upImg]);

  // set selected local type
  function handleLocalType(event) {
    setLocalType(event.target.value);
    action.fields.localType.value = event.target.value;
  }

  // delete uploading image
  function handleDeleteImage() {
    setFileName("");
    action.fields.completedCrop.value = [];
    action.fields.image.byteValue = "";
    action.fields.image.extension = "";
    action.fields.image.value = "";
    action.fields.fileName.value = "";
  }

  function handleChange(v) {
    setValue(v);
    if (v === 0) {
      setImgCoordinate({ coordinates: action.fields.completedCrop.value });
    } else {
      setImgCoordinate({ coordinates: action.fields.gridCrop.value });
    }
  }
  return (
    <div>
      <div className="form-element">
        {t(label + "IMAGE-PATH")}
        <div>
          {fileName?.length > 0 &&
            <div className="form-element-horizontal">
              <p>{fileName}</p>
              <HighlightOffIcon onClick={handleDeleteImage} style={{ paddingLeft: 5 }} />
            </div>}
            <div className="custom-file config-form">
                <input type="file" className="custom-file-input" accept="image/*" id="license-customFile" onChange={onSelectFile}/>
                <label className="custom-file-label content-overflow" htmlFor="license-customFile">{t('CONTENT.SETTINGS.GENERAL.CHOOSE')}</label>
            </div>
        </div>

      </div>
      <div className="form-element">
        <div className="condition-tabs">
          <button
            className={value === 0 ? 'condition-active' : ''}
            onClick={() => handleChange(0)}>
            {t(label + "CROP")}
          </button>
          <button
            className={value === 1 ? 'condition-active' : ''}
            onClick={() => handleChange(1)}>
            {t(label + "GRID-CROP")}
          </button>
        </div>
      </div>
      <div>
        <Button
          disabled={fileName?.length === 0}
          variant="outlined"
          onClick={() => setOpenCaptureArea(true)}
          style={{
            background: "#031226",
            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
            borderRadius: 4,
            color: "#fff",
            fontWeight: 700
          }}
        >
          {t(label + "CAPTURE-AREA")}
        </Button>
      </div>
      <TabPanel value={value} index={1}>
        <div className="form-element">
          {t(label + "ASSIGN-CROP-VALUE")}
          <VariablePicker
            action={action}
            inputName="gridVariable"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            filter="data table"
            isRequired={false}
          />
          <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
        </div>
      </TabPanel>
      <div className="form-element">
        {t(label + "PATH")}
        <TextInput
          action={action}
          inputName="imagePath"
          variables={variables}
          setOpenVariable={setOpenVariable}
          defaultValue=""
          isRequired={false}
        />
      </div>
      <div className="form-element">
        <Checkboxes
          action={action}
          options={options.checkboxes}
          inputName="isTrim"
          isRequired={false}
        />
      </div>
      <div className="form-element">
        {t(label + "SELECT-LOCALE")}
        <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
          <Select value={localType} onChange={handleLocalType} input={(localType) ? null : <BootstrapInput />}>
            <MenuItem value="BASEDONLOCALE">
              {t(label + "BASED-ON-LOCALE")}
            </MenuItem>
            <MenuItem value="ENGLISH">{t(label + "ENGLISH")}</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="form-element">
        {t(label + "ASSIGN-VALUE")}
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          filter="string"
          isRequired={true}
        />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
      </div>
      {openCaptureArea && (
        <CaptureArea
          imgCoordinate={imgCoordinate}
          setImgCoordinate={setImgCoordinate}
          action={action}
          upImg={upImg}
          setOpenCaptureArea={setOpenCaptureArea}
          setOpenVariable={setOpenVariable}
          variables={variables}
          isGrid={value}
        />
      )}
    </div>
  );
}

export default CaptureTextFromImage;
